import { api } from '../store/middleware/api'

const extendedApi = api.injectEndpoints({
  endpoints: (build) => ({
    signup: build.mutation({
      query: (body) => ({
        url:`/auth/signup`,
        method:"POST",
        body
      }),
    }),    
  }),
  overrideExisting: false,
})

export const { useSignupMutation } = extendedApi